import { DialogTitle, DialogTitleProps } from '@mildang/mui';
import { css, cx } from '@mildang/styled-system/css';
import { splitCssProps } from '@mildang/styled-system/jsx';
import { SystemStyleObject } from '@mildang/styled-system/types';

const rootStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export interface DialogHeaderProps extends DialogTitleProps {
  panda?: SystemStyleObject;
}

const DialogHeader = (props: DialogHeaderProps) => {
  const { children, panda, className, ...others } = props;
  const [cssProps] = splitCssProps(others);
  const { ...styleProps } = cssProps;

  return (
    <DialogTitle className={cx(rootStyle, css(styleProps, panda), className)} {...others}>
      {children}
    </DialogTitle>
  );
};

export default DialogHeader;
